
import { Options, Vue } from 'vue-class-component';
import { Inject, Prop } from 'vue-property-decorator';
import { TrustAPI } from '@/shared/modules/trust-api';
import { AccountingAppView, AuditTrailView } from '@/shared/modules/typescript-trustapi-client/models';
import AuditTrailModal from '../../audit-trail-modal/index.vue';
import { orderBy } from 'lodash';

@Options({
  components: {
    AuditTrailModal
  }
})
export default class AccountingSoftwareAuditTrailModal extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop({ default: {}})
  private accountingApp!: AccountingAppView;

  private loadingContent = false;
  private errorLoadingContent = false;

  private auditTrail: AuditTrailView[] = [];

  created(): void {
    this.loadAuditTrail();
  }

  private closeModal(): void {
    this.$emit('closeAuditTrailModal');
  }

  private async loadAuditTrail(): Promise<void> {
    try {
      this.errorLoadingContent = false;
      this.loadingContent = true;
      const resp: any =
        await this.apiService.AccountingAppApi?.apiV2AccountingAppGetAccountingAppAuditTrailsAccountingAppIdGet(
          this.accountingApp.id
        );
        this.auditTrail = resp.data.data as AuditTrailView[];
        this.auditTrail = orderBy(
          this.auditTrail,
          ['date'],
          ['desc']
        );
    } catch (err) {
      this.errorLoadingContent = true;
    } finally {
      this.loadingContent = false;
    }
  }

}

